import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import Faqs from "@/pages/Faqs";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import LawChanges from "@/pages/LawChanges";
import ResourceEqualityActionPlan from "@/pages/ResourceEqualityActionPlan";
import AdminHorizon from "@/pages/AdminHorizon";
import ResourceHarassmentTemplate from "@/pages/ResourceHarassmentTemplate";
import LegalPrivilege from "@/pages/LegalPrivilege";
import Kent from "@/pages/Kent";
import Uk from "@/pages/Uk";
import { PrivacyPolicy, CookiePolicy } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import CalculatorsHub from "@/pages/calculators/CalculatorsHub";
import HolidayCalculator from "@/pages/calculators/HolidayCalculator";
import RedundancyPayCalculator from "@/pages/calculators/RedundancyPayCalculator";
import NoticePeriodCalculator from "@/pages/calculators/NoticePeriodCalculator";
import ProRataSalaryCalculator from "@/pages/calculators/ProRataSalaryCalculator";
import RedundancyPackageCalculator from "@/pages/calculators/RedundancyPackageCalculator";
import BookUpdates from "@/pages/book/BookUpdates";
import EqualityHome from "@/pages/equality/EqualityHome";
import EmployersHub from "@/pages/equality/EmployersHub";
import EmployeesHub from "@/pages/equality/EmployeesHub";
import IsItProtected from "@/pages/equality/IsItProtected";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resources/harassment-risk-assessment-template" element={<ResourceHarassmentTemplate />} />
        <Route path="/legal-privilege-and-hr-advice" element={<LegalPrivilege />} />
        <Route path="/hr-consultant-kent" element={<Kent />} />
        <Route path="/hr-consultancy-uk" element={<Uk />} />
        <Route path="/calculators" element={<CalculatorsHub />} />
        <Route path="/calculators/holiday-entitlement-calculator" element={<HolidayCalculator />} />
        <Route path="/calculators/redundancy-pay-calculator" element={<RedundancyPayCalculator />} />
        <Route path="/calculators/notice-period-calculator" element={<NoticePeriodCalculator />} />
        <Route path="/calculators/pro-rata-salary-calculator" element={<ProRataSalaryCalculator />} />
        <Route path="/calculators/redundancy-package-tax-calculator" element={<RedundancyPackageCalculator />} />
        <Route path="/equality-at-work" element={<EqualityHome />} />
        <Route path="/equality-at-work/employers" element={<EmployersHub />} />
        <Route path="/equality-at-work/at-work" element={<EmployeesHub />} />
        <Route path="/equality-at-work/is-it-protected" element={<IsItProtected />} />
        <Route path="/resources/equality-action-plan-template" element={<ResourceEqualityActionPlan />} />
        <Route path="/law-changes" element={<LawChanges />} />
        <Route path="/admin/horizon" element={<AdminHorizon />} />
        <Route path="/book/updates" element={<BookUpdates />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <CookieBanner />
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
